import { ConnectorSpec } from '@integration-app/sdk'
import clsx from 'clsx'
import classes from 'routes/Connectors/Connector/components/ManagedAuthentication/managedAuthentication.module.css'
import { DOCS_LINK } from 'routes/constants'
import { useTrackingContext } from '../../../../components/Tracking/tracking-context'

export function ManagedAuthentication({
  connector,
}: {
  connector: ConnectorSpec
}) {
  const { addTrackingToUrl } = useTrackingContext()
  return (
    <div className={classes.wrapper}>
      <h2 className={clsx(classes.header, 'likeH3')}>Managed authentication</h2>
      <p>
        Connect your customer accounts in {connector.name} without researching
        its API, registering in a developer program, and getting your
        application approved. We take care of authentication, secure credentials
        storage, and token refreshes so you don't have to.
      </p>
      <p className={classes.descItem}>
        Just one line of code for you and one click for your customers:
      </p>
      <div className={classes.codeExampleWrapper}>
        <p className={classes.codeExample}>
          <span>iApp.integration('{connector.key}').open()</span>
        </p>
        {/*<button className={'button button__bordered size-l'}>Run it</button>*/}
      </div>
      <a
        href={`${DOCS_LINK}/your-app/create-connection`}
        target={'_blank'}
        className={classes.link}
      >
        Read full documentation
      </a>
      <div className={classes.createWrapper}>
        <a
          href={addTrackingToUrl('https://console.integration.app/login')}
          target={'_blank'}
          className={'button blue button__rounded'}
        >
          Get started for free
        </a>
        <p className={classes.codeDesc}>
          Add {connector.name} to your app in the next 30 minutes
        </p>
      </div>
    </div>
  )
}
